import queryString from "query-string";

import {
    GET_COMPETENCIES,
    GET_COMPETENCY_BY_ID,
    CREATE_COMPETENCY,
    UPDATE_COMPETENCY,
    DELETE_COMPETENCY,
    GET_COMPETENCY,
    GET_COMPETENCY_BY_NIK,
    DOWNLOAD_COMPETENCY_TEMPLATE,
    UPLOAD_COMPETENCY_FILE
} from "@/api/master-data/competency/competency";

const state = {
    competencies: [],
    competency:[],
    competencyDetail: {},
    competencyByNik: [],
    totalItems: 0,
    loading: false
};

const mutations = {
    SET_COMPETENCIES: (state, payload) => {
        state.competencies = payload.data || [];
        state.totalItems = payload.totalItems || 0;
    },
    SET_LOADING: (state, payload) => {
        state.loading = payload;
    },
    setCompetency: (states, payload) => {
        states.competency = payload
    },
    SET_COMPETENCY_DETAIL: (state, payload) => {
        state.competencyDetail = payload;
    },
    setCompetencyByNik: (states, payload) => {
        states.competencyByNik = payload;
    },
};

const getters = {
    getCompetencies: (state) => state.competencies,
    getCompetencyDetail: (state) => state.competencyDetail,
    getTotalItems: (state) => state.totalItems,
    getLoading: (state) => state.loading,
    CompetencyData: (states) => states.competencyByNik,
};

const actions = {
    getCompetencies: async ({ commit }, params) => {
        commit('SET_LOADING', true);
        try {
            const response = await GET_COMPETENCIES(params);
            if (response.data.httpCode === 200) {
                commit('SET_COMPETENCIES', response.data.data);
            } else {
                commit('SET_COMPETENCIES', { data: [], totalItems: 0 });
            }
        } catch (error) {
            console.error('Error fetching competencies:', error);
            commit('SET_COMPETENCIES', { data: [], totalItems: 0 });
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    createCompetency: async ({ commit }, data) => {
        commit('SET_LOADING', true);
        try {
            const response = await CREATE_COMPETENCY(data);
            return response.data;
        } catch (error) {
            console.error('Error creating competency:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    updateCompetency: async ({ commit }, { id, data }) => {
        commit('SET_LOADING', true);
        try {
            const response = await UPDATE_COMPETENCY(id, data);
            return response.data;
        } catch (error) {
            console.error('Error updating competency:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    getCompetencyById: async ({ commit }, id) => {
        commit('SET_LOADING', true);
        try {
            const response = await GET_COMPETENCY_BY_ID(id);
            if (response.data.httpCode === 200) {
                commit('SET_COMPETENCY_DETAIL', response.data.data);
                return response.data.data;
            } else {
                commit('SET_COMPETENCY_DETAIL', {});
                throw new Error('Failed to fetch competency details');
            }
        } catch (error) {
            console.error('Error fetching competency by ID:', error);
            commit('SET_COMPETENCY_DETAIL', {});
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    deleteCompetency: async ({ commit }, id) => {
        commit('SET_LOADING', true);
        try {
            const response = await DELETE_COMPETENCY(id);
            return response.data;
        } catch (error) {
            console.error('Error deleting competency:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    getDataCompetency: async ({ commit }, args) => {
        const params = queryString.stringify(args);

        try {
            const resp = await GET_COMPETENCY(params);
            if (resp.data.httpCode === 200) {
                commit("setCompetency", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCompetency", []);
            }
            throw err;
        }
    },
    
    getDataCompetencyByNik: async ({ commit }, args) => {
        const params = queryString.stringify(args);
     
        try {
            const resp = await GET_COMPETENCY_BY_NIK(params);
            if (resp.data.httpCode === 200) {
                commit("setCompetencyByNik", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCompetencyByNik", []);
            }
            throw err;
        }
    },

    downloadCompetencyTemplate: async ({ commit }) => {
        commit('SET_LOADING', true);
        try {
            const response = await DOWNLOAD_COMPETENCY_TEMPLATE();
            return response;
        } catch (error) {
            console.error('Error downloading competency template:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    uploadCompetencyFile: async ({ commit }, formData) => {
        commit('SET_LOADING', true);
        try {
            const response = await UPLOAD_COMPETENCY_FILE(formData);
            return response.data;
        } catch (error) {
            console.error('Error uploading competency file:', error);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};